import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Stack, Typography } from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles';
import "@uppy/core/dist/style.min.css";
import { FC } from "react";
import Dropzone, { DropEvent, FileRejection } from "react-dropzone";

interface ITranscriptDropzoneProps {
    onDrop: <T extends File>(
        acceptedFiles: T[],
        fileRejections: FileRejection[],
        event: DropEvent
    ) => void;
    isTeamMember:boolean;
}

const TRANSCRIPT_DROPZONE_CONTAINER_STYLES = (theme: Theme)=> ({
    padding: "16px",
    width: "100%",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    border: `2px dashed ${theme.custom.borderGrey}`,
    borderRadius: "4px",
    cursor: "pointer",
});

const TranscriptDropzone: FC<ITranscriptDropzoneProps> = (props) => {
    const { onDrop,isTeamMember} = props;
    const theme = useTheme();
    return (
        <Dropzone
            onDrop={onDrop}
            multiple={false}
            accept={{
                "video/*": [],
                "audio/*": [],
            }}
            disabled={!isTeamMember}
        >
            {({ getRootProps, getInputProps }) => (
                <Box {...getRootProps({ sx: TRANSCRIPT_DROPZONE_CONTAINER_STYLES(theme) })}>
                    <input {...getInputProps()} />
                    <Stack sx={{ alignItems: "center" }}>
                        <FileDownloadIcon
                            sx={{ color: theme.custom.disabledColor, fontSize: "96px" }}
                        />
                        <Typography>Drop file here or click to browse.</Typography>
                    </Stack>
                </Box>
            )}
        </Dropzone>
    );
};

export default TranscriptDropzone;
